(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './fixers-f2-f2-dsl-f2-dsl-cqrs.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./fixers-f2-f2-dsl-f2-dsl-cqrs.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'fixers-c2-c2-ssm-ssm-chaincode-ssm-chaincode-dsl'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'fixers-c2-c2-ssm-ssm-chaincode-ssm-chaincode-dsl'.");
    }
    if (typeof this['fixers-f2-f2-dsl-f2-dsl-cqrs'] === 'undefined') {
      throw new Error("Error loading module 'fixers-c2-c2-ssm-ssm-chaincode-ssm-chaincode-dsl'. Its dependency 'fixers-f2-f2-dsl-f2-dsl-cqrs' was not found. Please, check whether 'fixers-f2-f2-dsl-f2-dsl-cqrs' is loaded prior to 'fixers-c2-c2-ssm-ssm-chaincode-ssm-chaincode-dsl'.");
    }
    root['fixers-c2-c2-ssm-ssm-chaincode-ssm-chaincode-dsl'] = factory(typeof this['fixers-c2-c2-ssm-ssm-chaincode-ssm-chaincode-dsl'] === 'undefined' ? {} : this['fixers-c2-c2-ssm-ssm-chaincode-ssm-chaincode-dsl'], this['kotlin-kotlin-stdlib'], this['fixers-f2-f2-dsl-f2-dsl-cqrs']);
  }
}(this, function (_, kotlin_kotlin, kotlin_io_komune_f2_f2_dsl_cqrs) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.fa;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var Query = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.e;
  var VOID = kotlin_kotlin.$_$.g;
  var Event = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.d;
  var defineProp = kotlin_kotlin.$_$.b9;
  var classMeta = kotlin_kotlin.$_$.z8;
  var THROW_IAE = kotlin_kotlin.$_$.ld;
  var Unit_instance = kotlin_kotlin.$_$.t4;
  var Enum = kotlin_kotlin.$_$.zc;
  var objectMeta = kotlin_kotlin.$_$.ea;
  var getKClassFromExpression = kotlin_kotlin.$_$.e;
  var THROW_CCE = kotlin_kotlin.$_$.kd;
  var contentEquals = kotlin_kotlin.$_$.m5;
  var getStringHashCode = kotlin_kotlin.$_$.i9;
  var contentHashCode = kotlin_kotlin.$_$.n5;
  var toString = kotlin_kotlin.$_$.ka;
  var hashCode = kotlin_kotlin.$_$.j9;
  var equals = kotlin_kotlin.$_$.c9;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.o;
  var toString_0 = kotlin_kotlin.$_$.le;
  var split = kotlin_kotlin.$_$.wb;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.m1;
  var first = kotlin_kotlin.$_$.h6;
  //endregion
  //region block: pre-declaration
  setMetadataFor(SsmChaincodeQueries, 'SsmChaincodeQueries', interfaceMeta);
  setMetadataFor(SsmQueryDTO, 'SsmQueryDTO', interfaceMeta, VOID, [Query]);
  setMetadataFor(SsmItemResultDTO, 'SsmItemResultDTO', interfaceMeta, VOID, [Event]);
  setMetadataFor(SsmItemsResultDTO, 'SsmItemsResultDTO', interfaceMeta, VOID, [Event]);
  setMetadataFor(BlockDTO, 'BlockDTO', interfaceMeta);
  setMetadataFor(Block, 'Block', classMeta, VOID, [BlockDTO]);
  setMetadataFor(EnvelopeType, 'EnvelopeType', classMeta, Enum);
  setMetadataFor(IdentitiesInfoDTO, 'IdentitiesInfoDTO', interfaceMeta);
  setMetadataFor(IdentitiesInfo, 'IdentitiesInfo', classMeta, VOID, [IdentitiesInfoDTO]);
  setMetadataFor(TransactionDTO, 'TransactionDTO', interfaceMeta);
  setMetadataFor(Transaction, 'Transaction', classMeta, VOID, [TransactionDTO]);
  setMetadataFor(InvokeChunkedProps, 'InvokeChunkedProps', classMeta, VOID, VOID, InvokeChunkedProps);
  setMetadataFor(SsmChaincodePropertiesDTO, 'SsmChaincodePropertiesDTO', interfaceMeta);
  setMetadataFor(ChaincodeSsmConfig, 'SsmChaincodeConfig', classMeta, VOID, [SsmChaincodePropertiesDTO]);
  setMetadataFor(AgentDTO, 'AgentDTO', interfaceMeta);
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor(Agent, 'Agent', classMeta, VOID, [AgentDTO]);
  setMetadataFor(ChaincodeDTO, 'ChaincodeDTO', interfaceMeta);
  setMetadataFor(Chaincode, 'Chaincode', classMeta, VOID, [ChaincodeDTO]);
  setMetadataFor(SsmDTO, 'SsmDTO', interfaceMeta);
  setMetadataFor(Ssm, 'Ssm', classMeta, VOID, [SsmDTO]);
  setMetadataFor(WithPrivate, 'WithPrivate', interfaceMeta);
  setMetadataFor(SsmContextDTO, 'SsmContextDTO', interfaceMeta, VOID, [WithPrivate]);
  setMetadataFor(SsmContext, 'SsmContext', classMeta, VOID, [SsmContextDTO]);
  setMetadataFor(SsmGrantDTO, 'SsmGrantDTO', interfaceMeta);
  setMetadataFor(SsmGrant, 'SsmGrant', classMeta);
  setMetadataFor(CreditDTO, 'CreditDTO', interfaceMeta);
  setMetadataFor(Credit, 'Credit', classMeta, VOID, [CreditDTO]);
  setMetadataFor(SsmSessionDTO, 'SsmSessionDTO', interfaceMeta, VOID, [WithPrivate]);
  setMetadataFor(SsmSession, 'SsmSession', classMeta, VOID, [SsmSessionDTO]);
  setMetadataFor(SsmSessionStateDTO, 'SsmSessionStateDTO', interfaceMeta, VOID, [SsmSessionDTO, WithPrivate]);
  setMetadataFor(SsmSessionState, 'SsmSessionState', classMeta, VOID, [SsmSessionStateDTO]);
  setMetadataFor(SsmSessionStateLogDTO, 'SsmSessionStateLogDTO', interfaceMeta);
  setMetadataFor(SsmSessionStateLog, 'SsmSessionStateLog', classMeta, VOID, [SsmSessionStateLogDTO]);
  setMetadataFor(SsmTransitionDTO, 'SsmTransitionDTO', interfaceMeta);
  setMetadataFor(SsmTransition, 'SsmTransition', classMeta, VOID, [SsmTransitionDTO]);
  setMetadataFor(ChaincodeUriDTO, 'ChaincodeUriDTO', interfaceMeta);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor(ChaincodeUri, 'ChaincodeUri', classMeta, VOID, [ChaincodeUriDTO]);
  setMetadataFor(SsmUriDTO, 'SsmUriDTO', interfaceMeta);
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor(SsmUri, 'SsmUri', classMeta, VOID, [SsmUriDTO]);
  setMetadataFor(SsmGetAdminQuery, 'SsmGetAdminQuery', classMeta, VOID, [SsmQueryDTO]);
  setMetadataFor(SsmGetAdminResult, 'SsmGetAdminResult', classMeta, VOID, [SsmItemResultDTO]);
  setMetadataFor(SsmGetQuery, 'SsmGetQuery', classMeta, VOID, [SsmQueryDTO]);
  setMetadataFor(SsmGetResult, 'SsmGetResult', classMeta, VOID, [SsmItemResultDTO]);
  setMetadataFor(SsmGetSessionLogsQuery, 'SsmGetSessionLogsQuery', classMeta, VOID, [SsmQueryDTO]);
  setMetadataFor(SsmGetSessionLogsQueryResult, 'SsmGetSessionLogsQueryResult', classMeta);
  setMetadataFor(SsmGetSessionQuery, 'SsmGetSessionQuery', classMeta, VOID, [SsmQueryDTO]);
  setMetadataFor(SsmGetSessionResult, 'SsmGetSessionResult', classMeta, VOID, [SsmItemResultDTO]);
  setMetadataFor(SsmGetTransactionQuery, 'SsmGetTransactionQuery', classMeta, VOID, [SsmQueryDTO]);
  setMetadataFor(SsmGetTransactionQueryResult, 'SsmGetTransactionQueryResult', classMeta, VOID, [SsmItemResultDTO]);
  setMetadataFor(SsmGetUserQuery, 'SsmGetUserQuery', classMeta, VOID, [SsmQueryDTO]);
  setMetadataFor(SsmGetUserResult, 'SsmGetUserResult', classMeta, VOID, [SsmItemResultDTO]);
  setMetadataFor(SsmListAdminQuery, 'SsmListAdminQuery', classMeta, VOID, [SsmQueryDTO]);
  setMetadataFor(SsmListAdminResult, 'SsmListAdminResult', classMeta, VOID, [SsmItemsResultDTO]);
  setMetadataFor(SsmListSessionQuery, 'SsmListSessionQuery', classMeta, VOID, [SsmQueryDTO]);
  setMetadataFor(SsmListSessionResult, 'SsmListSessionResult', classMeta, VOID, [SsmItemsResultDTO]);
  setMetadataFor(SsmListSsmQuery, 'SsmListSsmQuery', classMeta, VOID, [SsmQueryDTO]);
  setMetadataFor(SsmListSsmResult, 'SsmListSsmResult', classMeta, VOID, [SsmItemsResultDTO]);
  setMetadataFor(SsmListUserQuery, 'SsmListUserQuery', classMeta, VOID, [SsmQueryDTO]);
  setMetadataFor(SsmListUserResult, 'SsmListUserResult', classMeta, VOID, [SsmItemsResultDTO]);
  //endregion
  function SsmChaincodeQueries() {
  }
  function SsmQueryDTO() {
  }
  function SsmItemResultDTO() {
  }
  function SsmItemsResultDTO() {
  }
  function BlockDTO() {
  }
  function Block(blockId, previousHash, dataHash, transactions) {
    this.v20_1 = blockId;
    this.w20_1 = previousHash;
    this.x20_1 = dataHash;
    this.y20_1 = transactions;
  }
  protoOf(Block).r20 = function () {
    return this.v20_1;
  };
  protoOf(Block).s20 = function () {
    return this.w20_1;
  };
  protoOf(Block).t20 = function () {
    return this.x20_1;
  };
  protoOf(Block).u20 = function () {
    return this.y20_1;
  };
  var EnvelopeType_TRANSACTION_ENVELOPE_instance;
  var EnvelopeType_ENVELOPE_instance;
  function values() {
    return [EnvelopeType_TRANSACTION_ENVELOPE_getInstance(), EnvelopeType_ENVELOPE_getInstance()];
  }
  function valueOf(value) {
    switch (value) {
      case 'TRANSACTION_ENVELOPE':
        return EnvelopeType_TRANSACTION_ENVELOPE_getInstance();
      case 'ENVELOPE':
        return EnvelopeType_ENVELOPE_getInstance();
      default:
        EnvelopeType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var EnvelopeType_entriesInitialized;
  function EnvelopeType_initEntries() {
    if (EnvelopeType_entriesInitialized)
      return Unit_instance;
    EnvelopeType_entriesInitialized = true;
    EnvelopeType_TRANSACTION_ENVELOPE_instance = new EnvelopeType('TRANSACTION_ENVELOPE', 0);
    EnvelopeType_ENVELOPE_instance = new EnvelopeType('ENVELOPE', 1);
  }
  function EnvelopeType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function EnvelopeType_TRANSACTION_ENVELOPE_getInstance() {
    EnvelopeType_initEntries();
    return EnvelopeType_TRANSACTION_ENVELOPE_instance;
  }
  function EnvelopeType_ENVELOPE_getInstance() {
    EnvelopeType_initEntries();
    return EnvelopeType_ENVELOPE_instance;
  }
  function IdentitiesInfoDTO() {
  }
  function IdentitiesInfo(id, mspid) {
    this.c21_1 = id;
    this.d21_1 = mspid;
  }
  protoOf(IdentitiesInfo).k1y = function () {
    return this.c21_1;
  };
  protoOf(IdentitiesInfo).b21 = function () {
    return this.d21_1;
  };
  function TransactionDTO() {
  }
  function Transaction(transactionId, blockId, timestamp, isValid, channelId, creator, nonce, type, validationCode) {
    this.l21_1 = transactionId;
    this.m21_1 = blockId;
    this.n21_1 = timestamp;
    this.o21_1 = isValid;
    this.p21_1 = channelId;
    this.q21_1 = creator;
    this.r21_1 = nonce;
    this.s21_1 = type;
    this.t21_1 = validationCode;
  }
  protoOf(Transaction).e21 = function () {
    return this.l21_1;
  };
  protoOf(Transaction).r20 = function () {
    return this.m21_1;
  };
  protoOf(Transaction).l1y = function () {
    return this.n21_1;
  };
  protoOf(Transaction).f21 = function () {
    return this.o21_1;
  };
  protoOf(Transaction).g21 = function () {
    return this.p21_1;
  };
  protoOf(Transaction).h21 = function () {
    return this.q21_1;
  };
  protoOf(Transaction).i21 = function () {
    return this.r21_1;
  };
  protoOf(Transaction).j21 = function () {
    return this.s21_1;
  };
  protoOf(Transaction).k21 = function () {
    return this.t21_1;
  };
  function InvokeChunkedProps(size) {
    size = size === VOID ? 128 : size;
    this.u21_1 = size;
  }
  function SsmChaincodePropertiesDTO() {
  }
  function ChaincodeSsmConfig(url, chunking) {
    chunking = chunking === VOID ? new InvokeChunkedProps() : chunking;
    this.x21_1 = url;
    this.y21_1 = chunking;
  }
  protoOf(ChaincodeSsmConfig).v21 = function () {
    return this.x21_1;
  };
  protoOf(ChaincodeSsmConfig).w21 = function () {
    return this.y21_1;
  };
  function AgentDTO() {
  }
  function Companion() {
  }
  var Companion_instance;
  function Companion_getInstance() {
    return Companion_instance;
  }
  function Agent(name, pub) {
    this.a22_1 = name;
    this.b22_1 = pub;
  }
  protoOf(Agent).h9 = function () {
    return this.a22_1;
  };
  protoOf(Agent).z21 = function () {
    return this.b22_1;
  };
  protoOf(Agent).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof Agent))
      THROW_CCE();
    if (!(this.a22_1 === other.a22_1))
      return false;
    if (!contentEquals(this.b22_1, other.b22_1))
      return false;
    return true;
  };
  protoOf(Agent).hashCode = function () {
    var result = getStringHashCode(this.a22_1);
    result = imul(31, result) + contentHashCode(this.b22_1) | 0;
    return result;
  };
  protoOf(Agent).md = function () {
    return this.a22_1;
  };
  protoOf(Agent).nd = function () {
    return this.b22_1;
  };
  protoOf(Agent).c22 = function (name, pub) {
    return new Agent(name, pub);
  };
  protoOf(Agent).copy = function (name, pub, $super) {
    name = name === VOID ? this.a22_1 : name;
    pub = pub === VOID ? this.b22_1 : pub;
    return this.c22(name, pub);
  };
  protoOf(Agent).toString = function () {
    return 'Agent(name=' + this.a22_1 + ', pub=' + toString(this.b22_1) + ')';
  };
  function ChaincodeDTO() {
  }
  function Chaincode(id, channelId) {
    this.d22_1 = id;
    this.e22_1 = channelId;
  }
  protoOf(Chaincode).k1y = function () {
    return this.d22_1;
  };
  protoOf(Chaincode).g21 = function () {
    return this.e22_1;
  };
  protoOf(Chaincode).md = function () {
    return this.d22_1;
  };
  protoOf(Chaincode).nd = function () {
    return this.e22_1;
  };
  protoOf(Chaincode).f22 = function (id, channelId) {
    return new Chaincode(id, channelId);
  };
  protoOf(Chaincode).copy = function (id, channelId, $super) {
    id = id === VOID ? this.d22_1 : id;
    channelId = channelId === VOID ? this.e22_1 : channelId;
    return this.f22(id, channelId);
  };
  protoOf(Chaincode).toString = function () {
    return 'Chaincode(id=' + this.d22_1 + ', channelId=' + this.e22_1 + ')';
  };
  protoOf(Chaincode).hashCode = function () {
    var result = getStringHashCode(this.d22_1);
    result = imul(result, 31) + getStringHashCode(this.e22_1) | 0;
    return result;
  };
  protoOf(Chaincode).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Chaincode))
      return false;
    var tmp0_other_with_cast = other instanceof Chaincode ? other : THROW_CCE();
    if (!(this.d22_1 === tmp0_other_with_cast.d22_1))
      return false;
    if (!(this.e22_1 === tmp0_other_with_cast.e22_1))
      return false;
    return true;
  };
  function SsmDTO() {
  }
  function Ssm(name, transitions) {
    this.h22_1 = name;
    this.i22_1 = transitions;
  }
  protoOf(Ssm).h9 = function () {
    return this.h22_1;
  };
  protoOf(Ssm).g22 = function () {
    return this.i22_1;
  };
  protoOf(Ssm).md = function () {
    return this.h22_1;
  };
  protoOf(Ssm).nd = function () {
    return this.i22_1;
  };
  protoOf(Ssm).j22 = function (name, transitions) {
    return new Ssm(name, transitions);
  };
  protoOf(Ssm).copy = function (name, transitions, $super) {
    name = name === VOID ? this.h22_1 : name;
    transitions = transitions === VOID ? this.i22_1 : transitions;
    return this.j22(name, transitions);
  };
  protoOf(Ssm).toString = function () {
    return 'Ssm(name=' + this.h22_1 + ', transitions=' + this.i22_1 + ')';
  };
  protoOf(Ssm).hashCode = function () {
    var result = getStringHashCode(this.h22_1);
    result = imul(result, 31) + hashCode(this.i22_1) | 0;
    return result;
  };
  protoOf(Ssm).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Ssm))
      return false;
    var tmp0_other_with_cast = other instanceof Ssm ? other : THROW_CCE();
    if (!(this.h22_1 === tmp0_other_with_cast.h22_1))
      return false;
    if (!equals(this.i22_1, tmp0_other_with_cast.i22_1))
      return false;
    return true;
  };
  function SsmContextDTO() {
  }
  function SsmContext(session, public_0, iteration, private_0) {
    private_0 = private_0 === VOID ? null : private_0;
    this.o22_1 = session;
    this.p22_1 = public_0;
    this.q22_1 = iteration;
    this.r22_1 = private_0;
  }
  protoOf(SsmContext).k22 = function () {
    return this.o22_1;
  };
  protoOf(SsmContext).l22 = function () {
    return this.p22_1;
  };
  protoOf(SsmContext).m22 = function () {
    return this.q22_1;
  };
  protoOf(SsmContext).n22 = function () {
    return this.r22_1;
  };
  protoOf(SsmContext).md = function () {
    return this.o22_1;
  };
  protoOf(SsmContext).nd = function () {
    return this.p22_1;
  };
  protoOf(SsmContext).s22 = function () {
    return this.q22_1;
  };
  protoOf(SsmContext).t22 = function () {
    return this.r22_1;
  };
  protoOf(SsmContext).u22 = function (session, public_0, iteration, private_0) {
    return new SsmContext(session, public_0, iteration, private_0);
  };
  protoOf(SsmContext).copy = function (session, public_0, iteration, private_0, $super) {
    session = session === VOID ? this.o22_1 : session;
    public_0 = public_0 === VOID ? this.p22_1 : public_0;
    iteration = iteration === VOID ? this.q22_1 : iteration;
    private_0 = private_0 === VOID ? this.r22_1 : private_0;
    return this.u22(session, public_0, iteration, private_0);
  };
  protoOf(SsmContext).toString = function () {
    return 'SsmContext(session=' + this.o22_1 + ', public=' + this.p22_1 + ', iteration=' + this.q22_1 + ', private=' + this.r22_1 + ')';
  };
  protoOf(SsmContext).hashCode = function () {
    var result = getStringHashCode(this.o22_1);
    result = imul(result, 31) + getStringHashCode(this.p22_1) | 0;
    result = imul(result, 31) + this.q22_1 | 0;
    result = imul(result, 31) + (this.r22_1 == null ? 0 : hashCode(this.r22_1)) | 0;
    return result;
  };
  protoOf(SsmContext).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SsmContext))
      return false;
    var tmp0_other_with_cast = other instanceof SsmContext ? other : THROW_CCE();
    if (!(this.o22_1 === tmp0_other_with_cast.o22_1))
      return false;
    if (!(this.p22_1 === tmp0_other_with_cast.p22_1))
      return false;
    if (!(this.q22_1 === tmp0_other_with_cast.q22_1))
      return false;
    if (!equals(this.r22_1, tmp0_other_with_cast.r22_1))
      return false;
    return true;
  };
  function SsmGrantDTO() {
  }
  function SsmGrant(user, iteration, credits) {
    this.user = user;
    this.iteration = iteration;
    this.credits = credits;
  }
  protoOf(SsmGrant).v22 = function () {
    return this.user;
  };
  protoOf(SsmGrant).m22 = function () {
    return this.iteration;
  };
  protoOf(SsmGrant).w22 = function () {
    return this.credits;
  };
  protoOf(SsmGrant).md = function () {
    return this.user;
  };
  protoOf(SsmGrant).nd = function () {
    return this.iteration;
  };
  protoOf(SsmGrant).s22 = function () {
    return this.credits;
  };
  protoOf(SsmGrant).x22 = function (user, iteration, credits) {
    return new SsmGrant(user, iteration, credits);
  };
  protoOf(SsmGrant).copy = function (user, iteration, credits, $super) {
    user = user === VOID ? this.user : user;
    iteration = iteration === VOID ? this.iteration : iteration;
    credits = credits === VOID ? this.credits : credits;
    return this.x22(user, iteration, credits);
  };
  protoOf(SsmGrant).toString = function () {
    return 'SsmGrant(user=' + this.user + ', iteration=' + this.iteration + ', credits=' + this.credits + ')';
  };
  protoOf(SsmGrant).hashCode = function () {
    var result = getStringHashCode(this.user);
    result = imul(result, 31) + this.iteration | 0;
    result = imul(result, 31) + hashCode(this.credits) | 0;
    return result;
  };
  protoOf(SsmGrant).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SsmGrant))
      return false;
    var tmp0_other_with_cast = other instanceof SsmGrant ? other : THROW_CCE();
    if (!(this.user === tmp0_other_with_cast.user))
      return false;
    if (!(this.iteration === tmp0_other_with_cast.iteration))
      return false;
    if (!equals(this.credits, tmp0_other_with_cast.credits))
      return false;
    return true;
  };
  function CreditDTO() {
  }
  function Credit(amount) {
    this.z22_1 = amount;
  }
  protoOf(Credit).y22 = function () {
    return this.z22_1;
  };
  protoOf(Credit).md = function () {
    return this.z22_1;
  };
  protoOf(Credit).a23 = function (amount) {
    return new Credit(amount);
  };
  protoOf(Credit).copy = function (amount, $super) {
    amount = amount === VOID ? this.z22_1 : amount;
    return this.a23(amount);
  };
  protoOf(Credit).toString = function () {
    return 'Credit(amount=' + this.z22_1 + ')';
  };
  protoOf(Credit).hashCode = function () {
    return this.z22_1;
  };
  protoOf(Credit).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Credit))
      return false;
    var tmp0_other_with_cast = other instanceof Credit ? other : THROW_CCE();
    if (!(this.z22_1 === tmp0_other_with_cast.z22_1))
      return false;
    return true;
  };
  function SsmSessionDTO() {
  }
  function SsmSession(ssm, session, roles, public_0, private_0) {
    var tmp;
    if (private_0 === VOID) {
      // Inline function 'kotlin.collections.hashMapOf' call
      tmp = HashMap_init_$Create$();
    } else {
      tmp = private_0;
    }
    private_0 = tmp;
    this.d23_1 = ssm;
    this.e23_1 = session;
    this.f23_1 = roles;
    this.g23_1 = public_0;
    this.h23_1 = private_0;
  }
  protoOf(SsmSession).b23 = function () {
    return this.d23_1;
  };
  protoOf(SsmSession).k22 = function () {
    return this.e23_1;
  };
  protoOf(SsmSession).c23 = function () {
    return this.f23_1;
  };
  protoOf(SsmSession).l22 = function () {
    return this.g23_1;
  };
  protoOf(SsmSession).n22 = function () {
    return this.h23_1;
  };
  function SsmSessionStateDTO() {
  }
  function SsmSessionState(ssm, session, roles, public_0, private_0, origin, current, iteration) {
    var tmp;
    if (private_0 === VOID) {
      // Inline function 'kotlin.collections.hashMapOf' call
      tmp = HashMap_init_$Create$();
    } else {
      tmp = private_0;
    }
    private_0 = tmp;
    this.k23_1 = ssm;
    this.l23_1 = session;
    this.m23_1 = roles;
    this.n23_1 = public_0;
    this.o23_1 = private_0;
    this.p23_1 = origin;
    this.q23_1 = current;
    this.r23_1 = iteration;
  }
  protoOf(SsmSessionState).b23 = function () {
    return this.k23_1;
  };
  protoOf(SsmSessionState).k22 = function () {
    return this.l23_1;
  };
  protoOf(SsmSessionState).c23 = function () {
    return this.m23_1;
  };
  protoOf(SsmSessionState).l22 = function () {
    return this.n23_1;
  };
  protoOf(SsmSessionState).n22 = function () {
    return this.o23_1;
  };
  protoOf(SsmSessionState).i23 = function () {
    return this.p23_1;
  };
  protoOf(SsmSessionState).j23 = function () {
    return this.q23_1;
  };
  protoOf(SsmSessionState).m22 = function () {
    return this.r23_1;
  };
  protoOf(SsmSessionState).md = function () {
    return this.k23_1;
  };
  protoOf(SsmSessionState).nd = function () {
    return this.l23_1;
  };
  protoOf(SsmSessionState).s22 = function () {
    return this.m23_1;
  };
  protoOf(SsmSessionState).t22 = function () {
    return this.n23_1;
  };
  protoOf(SsmSessionState).s23 = function () {
    return this.o23_1;
  };
  protoOf(SsmSessionState).t23 = function () {
    return this.p23_1;
  };
  protoOf(SsmSessionState).u23 = function () {
    return this.q23_1;
  };
  protoOf(SsmSessionState).v23 = function () {
    return this.r23_1;
  };
  protoOf(SsmSessionState).w23 = function (ssm, session, roles, public_0, private_0, origin, current, iteration) {
    return new SsmSessionState(ssm, session, roles, public_0, private_0, origin, current, iteration);
  };
  protoOf(SsmSessionState).copy = function (ssm, session, roles, public_0, private_0, origin, current, iteration, $super) {
    ssm = ssm === VOID ? this.k23_1 : ssm;
    session = session === VOID ? this.l23_1 : session;
    roles = roles === VOID ? this.m23_1 : roles;
    public_0 = public_0 === VOID ? this.n23_1 : public_0;
    private_0 = private_0 === VOID ? this.o23_1 : private_0;
    origin = origin === VOID ? this.p23_1 : origin;
    current = current === VOID ? this.q23_1 : current;
    iteration = iteration === VOID ? this.r23_1 : iteration;
    return this.w23(ssm, session, roles, public_0, private_0, origin, current, iteration);
  };
  protoOf(SsmSessionState).toString = function () {
    return 'SsmSessionState(ssm=' + this.k23_1 + ', session=' + this.l23_1 + ', roles=' + this.m23_1 + ', public=' + toString_0(this.n23_1) + ', private=' + this.o23_1 + ', origin=' + this.p23_1 + ', current=' + this.q23_1 + ', iteration=' + this.r23_1 + ')';
  };
  protoOf(SsmSessionState).hashCode = function () {
    var result = this.k23_1 == null ? 0 : getStringHashCode(this.k23_1);
    result = imul(result, 31) + getStringHashCode(this.l23_1) | 0;
    result = imul(result, 31) + (this.m23_1 == null ? 0 : hashCode(this.m23_1)) | 0;
    result = imul(result, 31) + (this.n23_1 == null ? 0 : hashCode(this.n23_1)) | 0;
    result = imul(result, 31) + (this.o23_1 == null ? 0 : hashCode(this.o23_1)) | 0;
    result = imul(result, 31) + (this.p23_1 == null ? 0 : this.p23_1.hashCode()) | 0;
    result = imul(result, 31) + this.q23_1 | 0;
    result = imul(result, 31) + this.r23_1 | 0;
    return result;
  };
  protoOf(SsmSessionState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SsmSessionState))
      return false;
    var tmp0_other_with_cast = other instanceof SsmSessionState ? other : THROW_CCE();
    if (!(this.k23_1 == tmp0_other_with_cast.k23_1))
      return false;
    if (!(this.l23_1 === tmp0_other_with_cast.l23_1))
      return false;
    if (!equals(this.m23_1, tmp0_other_with_cast.m23_1))
      return false;
    if (!equals(this.n23_1, tmp0_other_with_cast.n23_1))
      return false;
    if (!equals(this.o23_1, tmp0_other_with_cast.o23_1))
      return false;
    if (!equals(this.p23_1, tmp0_other_with_cast.p23_1))
      return false;
    if (!(this.q23_1 === tmp0_other_with_cast.q23_1))
      return false;
    if (!(this.r23_1 === tmp0_other_with_cast.r23_1))
      return false;
    return true;
  };
  function SsmSessionStateLogDTO() {
  }
  function SsmSessionStateLog(txId, state) {
    this.y23_1 = txId;
    this.z23_1 = state;
  }
  protoOf(SsmSessionStateLog).x23 = function () {
    return this.y23_1;
  };
  protoOf(SsmSessionStateLog).wa = function () {
    return this.z23_1;
  };
  protoOf(SsmSessionStateLog).md = function () {
    return this.y23_1;
  };
  protoOf(SsmSessionStateLog).nd = function () {
    return this.z23_1;
  };
  protoOf(SsmSessionStateLog).a24 = function (txId, state) {
    return new SsmSessionStateLog(txId, state);
  };
  protoOf(SsmSessionStateLog).copy = function (txId, state, $super) {
    txId = txId === VOID ? this.y23_1 : txId;
    state = state === VOID ? this.z23_1 : state;
    return this.a24(txId, state);
  };
  protoOf(SsmSessionStateLog).toString = function () {
    return 'SsmSessionStateLog(txId=' + this.y23_1 + ', state=' + this.z23_1 + ')';
  };
  protoOf(SsmSessionStateLog).hashCode = function () {
    var result = getStringHashCode(this.y23_1);
    result = imul(result, 31) + this.z23_1.hashCode() | 0;
    return result;
  };
  protoOf(SsmSessionStateLog).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SsmSessionStateLog))
      return false;
    var tmp0_other_with_cast = other instanceof SsmSessionStateLog ? other : THROW_CCE();
    if (!(this.y23_1 === tmp0_other_with_cast.y23_1))
      return false;
    if (!this.z23_1.equals(tmp0_other_with_cast.z23_1))
      return false;
    return true;
  };
  function SsmTransitionDTO() {
  }
  function SsmTransition(from, to, role, action) {
    this.f24_1 = from;
    this.g24_1 = to;
    this.h24_1 = role;
    this.i24_1 = action;
  }
  protoOf(SsmTransition).b24 = function () {
    return this.f24_1;
  };
  protoOf(SsmTransition).c24 = function () {
    return this.g24_1;
  };
  protoOf(SsmTransition).d24 = function () {
    return this.h24_1;
  };
  protoOf(SsmTransition).e24 = function () {
    return this.i24_1;
  };
  protoOf(SsmTransition).md = function () {
    return this.f24_1;
  };
  protoOf(SsmTransition).nd = function () {
    return this.g24_1;
  };
  protoOf(SsmTransition).s22 = function () {
    return this.h24_1;
  };
  protoOf(SsmTransition).t22 = function () {
    return this.i24_1;
  };
  protoOf(SsmTransition).j24 = function (from, to, role, action) {
    return new SsmTransition(from, to, role, action);
  };
  protoOf(SsmTransition).copy = function (from, to, role, action, $super) {
    from = from === VOID ? this.f24_1 : from;
    to = to === VOID ? this.g24_1 : to;
    role = role === VOID ? this.h24_1 : role;
    action = action === VOID ? this.i24_1 : action;
    return this.j24(from, to, role, action);
  };
  protoOf(SsmTransition).toString = function () {
    return 'SsmTransition(from=' + this.f24_1 + ', to=' + this.g24_1 + ', role=' + this.h24_1 + ', action=' + this.i24_1 + ')';
  };
  protoOf(SsmTransition).hashCode = function () {
    var result = this.f24_1;
    result = imul(result, 31) + this.g24_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.h24_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i24_1) | 0;
    return result;
  };
  protoOf(SsmTransition).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SsmTransition))
      return false;
    var tmp0_other_with_cast = other instanceof SsmTransition ? other : THROW_CCE();
    if (!(this.f24_1 === tmp0_other_with_cast.f24_1))
      return false;
    if (!(this.g24_1 === tmp0_other_with_cast.g24_1))
      return false;
    if (!(this.h24_1 === tmp0_other_with_cast.h24_1))
      return false;
    if (!(this.i24_1 === tmp0_other_with_cast.i24_1))
      return false;
    return true;
  };
  function WithPrivate() {
  }
  function ChaincodeUriDTO() {
  }
  function Companion_0() {
    this.PARTS = 3;
    this.PREFIX = 'chaincode';
  }
  protoOf(Companion_0).l24 = function () {
    return this.PARTS;
  };
  protoOf(Companion_0).m24 = function () {
    return this.PREFIX;
  };
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function ChaincodeUri(uri) {
    this.n24_1 = uri;
    this.o24_1 = split(this.n24_1, [':']);
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.o24_1.n() === 3)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(first(this.o24_1) === 'chaincode')) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message_0 = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
  }
  protoOf(ChaincodeUri).k24 = function () {
    return this.n24_1;
  };
  protoOf(ChaincodeUri).g21 = function () {
    return this.o24_1.f1(1);
  };
  protoOf(ChaincodeUri).p24 = function () {
    return this.o24_1.f1(2);
  };
  function from(_this__u8e3s4, channelId, chaincodeId) {
    return new ChaincodeUri('chaincode:' + channelId + ':' + chaincodeId);
  }
  function SsmUriDTO() {
  }
  function Companion_1() {
    this.PARTS = 4;
    this.PREFIX = 'ssm';
  }
  protoOf(Companion_1).l24 = function () {
    return this.PARTS;
  };
  protoOf(Companion_1).m24 = function () {
    return this.PREFIX;
  };
  var Companion_instance_1;
  function Companion_getInstance_1() {
    return Companion_instance_1;
  }
  function SsmUri(uri) {
    this.q24_1 = uri;
    this.r24_1 = split(this.q24_1, [':']);
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.r24_1.n() === 4)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(first(this.r24_1) === 'ssm')) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message_0 = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
  }
  protoOf(SsmUri).k24 = function () {
    return this.q24_1;
  };
  protoOf(SsmUri).g21 = function () {
    return this.r24_1.f1(1);
  };
  protoOf(SsmUri).p24 = function () {
    return this.r24_1.f1(2);
  };
  protoOf(SsmUri).s24 = function () {
    return this.r24_1.f1(3);
  };
  protoOf(SsmUri).t24 = function () {
    return '1.0.0';
  };
  protoOf(SsmUri).p20 = function () {
    return from(Companion_instance_0, this.channelId, this.chaincodeId);
  };
  protoOf(SsmUri).md = function () {
    return this.q24_1;
  };
  protoOf(SsmUri).u24 = function (uri) {
    return new SsmUri(uri);
  };
  protoOf(SsmUri).copy = function (uri, $super) {
    uri = uri === VOID ? this.q24_1 : uri;
    return this.u24(uri);
  };
  protoOf(SsmUri).toString = function () {
    return 'SsmUri(uri=' + this.q24_1 + ')';
  };
  protoOf(SsmUri).hashCode = function () {
    return getStringHashCode(this.q24_1);
  };
  protoOf(SsmUri).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SsmUri))
      return false;
    var tmp0_other_with_cast = other instanceof SsmUri ? other : THROW_CCE();
    if (!(this.q24_1 === tmp0_other_with_cast.q24_1))
      return false;
    return true;
  };
  function SsmGetAdminQuery(chaincodeUri, name) {
    this.v24_1 = chaincodeUri;
    this.name = name;
  }
  protoOf(SsmGetAdminQuery).p20 = function () {
    return this.v24_1;
  };
  protoOf(SsmGetAdminQuery).h9 = function () {
    return this.name;
  };
  function SsmGetAdminResult(item) {
    this.w24_1 = item;
  }
  protoOf(SsmGetAdminResult).q20 = function () {
    return this.w24_1;
  };
  function SsmGetQuery(chaincodeUri, name) {
    this.x24_1 = chaincodeUri;
    this.name = name;
  }
  protoOf(SsmGetQuery).p20 = function () {
    return this.x24_1;
  };
  protoOf(SsmGetQuery).h9 = function () {
    return this.name;
  };
  function SsmGetResult(item) {
    this.y24_1 = item;
  }
  protoOf(SsmGetResult).q20 = function () {
    return this.y24_1;
  };
  function SsmGetSessionLogsQuery(chaincodeUri, ssmName, sessionName) {
    this.z24_1 = chaincodeUri;
    this.ssmName = ssmName;
    this.sessionName = sessionName;
  }
  protoOf(SsmGetSessionLogsQuery).p20 = function () {
    return this.z24_1;
  };
  protoOf(SsmGetSessionLogsQuery).s24 = function () {
    return this.ssmName;
  };
  protoOf(SsmGetSessionLogsQuery).a25 = function () {
    return this.sessionName;
  };
  function SsmGetSessionLogsQueryResult(ssmName, sessionName, logs) {
    this.ssmName = ssmName;
    this.sessionName = sessionName;
    this.logs = logs;
  }
  protoOf(SsmGetSessionLogsQueryResult).s24 = function () {
    return this.ssmName;
  };
  protoOf(SsmGetSessionLogsQueryResult).a25 = function () {
    return this.sessionName;
  };
  protoOf(SsmGetSessionLogsQueryResult).b25 = function () {
    return this.logs;
  };
  protoOf(SsmGetSessionLogsQueryResult).md = function () {
    return this.ssmName;
  };
  protoOf(SsmGetSessionLogsQueryResult).nd = function () {
    return this.sessionName;
  };
  protoOf(SsmGetSessionLogsQueryResult).s22 = function () {
    return this.logs;
  };
  protoOf(SsmGetSessionLogsQueryResult).c25 = function (ssmName, sessionName, logs) {
    return new SsmGetSessionLogsQueryResult(ssmName, sessionName, logs);
  };
  protoOf(SsmGetSessionLogsQueryResult).copy = function (ssmName, sessionName, logs, $super) {
    ssmName = ssmName === VOID ? this.ssmName : ssmName;
    sessionName = sessionName === VOID ? this.sessionName : sessionName;
    logs = logs === VOID ? this.logs : logs;
    return this.c25(ssmName, sessionName, logs);
  };
  protoOf(SsmGetSessionLogsQueryResult).toString = function () {
    return 'SsmGetSessionLogsQueryResult(ssmName=' + this.ssmName + ', sessionName=' + this.sessionName + ', logs=' + this.logs + ')';
  };
  protoOf(SsmGetSessionLogsQueryResult).hashCode = function () {
    var result = getStringHashCode(this.ssmName);
    result = imul(result, 31) + getStringHashCode(this.sessionName) | 0;
    result = imul(result, 31) + hashCode(this.logs) | 0;
    return result;
  };
  protoOf(SsmGetSessionLogsQueryResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SsmGetSessionLogsQueryResult))
      return false;
    var tmp0_other_with_cast = other instanceof SsmGetSessionLogsQueryResult ? other : THROW_CCE();
    if (!(this.ssmName === tmp0_other_with_cast.ssmName))
      return false;
    if (!(this.sessionName === tmp0_other_with_cast.sessionName))
      return false;
    if (!equals(this.logs, tmp0_other_with_cast.logs))
      return false;
    return true;
  };
  function SsmGetSessionQuery(chaincodeUri, sessionName) {
    this.d25_1 = chaincodeUri;
    this.sessionName = sessionName;
  }
  protoOf(SsmGetSessionQuery).p20 = function () {
    return this.d25_1;
  };
  protoOf(SsmGetSessionQuery).a25 = function () {
    return this.sessionName;
  };
  function SsmGetSessionResult(item) {
    this.e25_1 = item;
  }
  protoOf(SsmGetSessionResult).q20 = function () {
    return this.e25_1;
  };
  function SsmGetTransactionQuery(chaincodeUri, id) {
    this.f25_1 = chaincodeUri;
    this.id = id;
  }
  protoOf(SsmGetTransactionQuery).p20 = function () {
    return this.f25_1;
  };
  protoOf(SsmGetTransactionQuery).k1y = function () {
    return this.id;
  };
  protoOf(SsmGetTransactionQuery).md = function () {
    return this.f25_1;
  };
  protoOf(SsmGetTransactionQuery).nd = function () {
    return this.id;
  };
  protoOf(SsmGetTransactionQuery).g25 = function (chaincodeUri, id) {
    return new SsmGetTransactionQuery(chaincodeUri, id);
  };
  protoOf(SsmGetTransactionQuery).copy = function (chaincodeUri, id, $super) {
    chaincodeUri = chaincodeUri === VOID ? this.f25_1 : chaincodeUri;
    id = id === VOID ? this.id : id;
    return this.g25(chaincodeUri, id);
  };
  protoOf(SsmGetTransactionQuery).toString = function () {
    return 'SsmGetTransactionQuery(chaincodeUri=' + this.f25_1 + ', id=' + this.id + ')';
  };
  protoOf(SsmGetTransactionQuery).hashCode = function () {
    var result = hashCode(this.f25_1);
    result = imul(result, 31) + getStringHashCode(this.id) | 0;
    return result;
  };
  protoOf(SsmGetTransactionQuery).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SsmGetTransactionQuery))
      return false;
    var tmp0_other_with_cast = other instanceof SsmGetTransactionQuery ? other : THROW_CCE();
    if (!equals(this.f25_1, tmp0_other_with_cast.f25_1))
      return false;
    if (!(this.id === tmp0_other_with_cast.id))
      return false;
    return true;
  };
  function SsmGetTransactionQueryResult(item) {
    this.h25_1 = item;
  }
  protoOf(SsmGetTransactionQueryResult).q20 = function () {
    return this.h25_1;
  };
  function SsmGetUserQuery(chaincodeUri, name) {
    this.i25_1 = chaincodeUri;
    this.name = name;
  }
  protoOf(SsmGetUserQuery).p20 = function () {
    return this.i25_1;
  };
  protoOf(SsmGetUserQuery).h9 = function () {
    return this.name;
  };
  function SsmGetUserResult(item) {
    this.j25_1 = item;
  }
  protoOf(SsmGetUserResult).q20 = function () {
    return this.j25_1;
  };
  function SsmListAdminQuery(chaincodeUri) {
    this.k25_1 = chaincodeUri;
  }
  protoOf(SsmListAdminQuery).p20 = function () {
    return this.k25_1;
  };
  function SsmListAdminResult(items) {
    this.l25_1 = items;
  }
  protoOf(SsmListAdminResult).j1z = function () {
    return this.l25_1;
  };
  function SsmListSessionQuery(chaincodeUri) {
    this.m25_1 = chaincodeUri;
  }
  protoOf(SsmListSessionQuery).p20 = function () {
    return this.m25_1;
  };
  function SsmListSessionResult(items) {
    this.n25_1 = items;
  }
  protoOf(SsmListSessionResult).j1z = function () {
    return this.n25_1;
  };
  function SsmListSsmQuery(chaincodeUri) {
    this.o25_1 = chaincodeUri;
  }
  protoOf(SsmListSsmQuery).p20 = function () {
    return this.o25_1;
  };
  function SsmListSsmResult(items) {
    this.p25_1 = items;
  }
  protoOf(SsmListSsmResult).j1z = function () {
    return this.p25_1;
  };
  function SsmListUserQuery(chaincodeUri) {
    this.q25_1 = chaincodeUri;
  }
  protoOf(SsmListUserQuery).p20 = function () {
    return this.q25_1;
  };
  function SsmListUserResult(items) {
    this.r25_1 = items;
  }
  protoOf(SsmListUserResult).j1z = function () {
    return this.r25_1;
  };
  //region block: post-declaration
  defineProp(protoOf(Block), 'blockId', function () {
    return this.r20();
  });
  defineProp(protoOf(Block), 'previousHash', function () {
    return this.s20();
  });
  defineProp(protoOf(Block), 'dataHash', function () {
    return this.t20();
  });
  defineProp(protoOf(Block), 'transactions', function () {
    return this.u20();
  });
  defineProp(protoOf(EnvelopeType), 'name', protoOf(EnvelopeType).h9);
  defineProp(protoOf(EnvelopeType), 'ordinal', protoOf(EnvelopeType).i9);
  defineProp(protoOf(IdentitiesInfo), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(IdentitiesInfo), 'mspid', function () {
    return this.b21();
  });
  defineProp(protoOf(Transaction), 'transactionId', function () {
    return this.e21();
  });
  defineProp(protoOf(Transaction), 'blockId', function () {
    return this.r20();
  });
  defineProp(protoOf(Transaction), 'timestamp', function () {
    return this.l1y();
  });
  defineProp(protoOf(Transaction), 'isValid', function () {
    return this.f21();
  });
  defineProp(protoOf(Transaction), 'channelId', function () {
    return this.g21();
  });
  defineProp(protoOf(Transaction), 'creator', function () {
    return this.h21();
  });
  defineProp(protoOf(Transaction), 'nonce', function () {
    return this.i21();
  });
  defineProp(protoOf(Transaction), 'type', function () {
    return this.j21();
  });
  defineProp(protoOf(Transaction), 'validationCode', function () {
    return this.k21();
  });
  defineProp(protoOf(ChaincodeSsmConfig), 'url', function () {
    return this.v21();
  });
  defineProp(protoOf(ChaincodeSsmConfig), 'chunking', function () {
    return this.w21();
  });
  defineProp(protoOf(Agent), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(Agent), 'pub', function () {
    return this.z21();
  });
  defineProp(protoOf(Chaincode), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(Chaincode), 'channelId', function () {
    return this.g21();
  });
  defineProp(protoOf(Ssm), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(Ssm), 'transitions', function () {
    return this.g22();
  });
  defineProp(protoOf(SsmContext), 'session', function () {
    return this.k22();
  });
  defineProp(protoOf(SsmContext), 'public', function () {
    return this.l22();
  });
  defineProp(protoOf(SsmContext), 'iteration', function () {
    return this.m22();
  });
  defineProp(protoOf(SsmContext), 'private', function () {
    return this.n22();
  });
  defineProp(protoOf(Credit), 'amount', function () {
    return this.y22();
  });
  defineProp(protoOf(SsmSession), 'ssm', function () {
    return this.b23();
  });
  defineProp(protoOf(SsmSession), 'session', function () {
    return this.k22();
  });
  defineProp(protoOf(SsmSession), 'roles', function () {
    return this.c23();
  });
  defineProp(protoOf(SsmSession), 'public', function () {
    return this.l22();
  });
  defineProp(protoOf(SsmSession), 'private', function () {
    return this.n22();
  });
  defineProp(protoOf(SsmSessionState), 'ssm', function () {
    return this.b23();
  });
  defineProp(protoOf(SsmSessionState), 'session', function () {
    return this.k22();
  });
  defineProp(protoOf(SsmSessionState), 'roles', function () {
    return this.c23();
  });
  defineProp(protoOf(SsmSessionState), 'public', function () {
    return this.l22();
  });
  defineProp(protoOf(SsmSessionState), 'private', function () {
    return this.n22();
  });
  defineProp(protoOf(SsmSessionState), 'origin', function () {
    return this.i23();
  });
  defineProp(protoOf(SsmSessionState), 'current', function () {
    return this.j23();
  });
  defineProp(protoOf(SsmSessionState), 'iteration', function () {
    return this.m22();
  });
  defineProp(protoOf(SsmSessionStateLog), 'txId', function () {
    return this.x23();
  });
  defineProp(protoOf(SsmSessionStateLog), 'state', function () {
    return this.wa();
  });
  defineProp(protoOf(SsmTransition), 'from', function () {
    return this.b24();
  });
  defineProp(protoOf(SsmTransition), 'to', function () {
    return this.c24();
  });
  defineProp(protoOf(SsmTransition), 'role', function () {
    return this.d24();
  });
  defineProp(protoOf(SsmTransition), 'action', function () {
    return this.e24();
  });
  defineProp(protoOf(ChaincodeUri), 'uri', function () {
    return this.k24();
  });
  defineProp(protoOf(ChaincodeUri), 'channelId', protoOf(ChaincodeUri).g21);
  defineProp(protoOf(ChaincodeUri), 'chaincodeId', protoOf(ChaincodeUri).p24);
  defineProp(protoOf(SsmUri), 'uri', function () {
    return this.k24();
  });
  defineProp(protoOf(SsmUri), 'channelId', protoOf(SsmUri).g21);
  defineProp(protoOf(SsmUri), 'chaincodeId', protoOf(SsmUri).p24);
  defineProp(protoOf(SsmUri), 'ssmName', protoOf(SsmUri).s24);
  defineProp(protoOf(SsmUri), 'ssmVersion', protoOf(SsmUri).t24);
  defineProp(protoOf(SsmUri), 'chaincodeUri', protoOf(SsmUri).p20);
  defineProp(protoOf(SsmGetAdminQuery), 'chaincodeUri', function () {
    return this.p20();
  });
  defineProp(protoOf(SsmGetAdminResult), 'item', function () {
    return this.q20();
  });
  defineProp(protoOf(SsmGetQuery), 'chaincodeUri', function () {
    return this.p20();
  });
  defineProp(protoOf(SsmGetResult), 'item', function () {
    return this.q20();
  });
  defineProp(protoOf(SsmGetSessionLogsQuery), 'chaincodeUri', function () {
    return this.p20();
  });
  defineProp(protoOf(SsmGetSessionQuery), 'chaincodeUri', function () {
    return this.p20();
  });
  defineProp(protoOf(SsmGetSessionResult), 'item', function () {
    return this.q20();
  });
  defineProp(protoOf(SsmGetTransactionQuery), 'chaincodeUri', function () {
    return this.p20();
  });
  defineProp(protoOf(SsmGetTransactionQueryResult), 'item', function () {
    return this.q20();
  });
  defineProp(protoOf(SsmGetUserQuery), 'chaincodeUri', function () {
    return this.p20();
  });
  defineProp(protoOf(SsmGetUserResult), 'item', function () {
    return this.q20();
  });
  defineProp(protoOf(SsmListAdminQuery), 'chaincodeUri', function () {
    return this.p20();
  });
  defineProp(protoOf(SsmListAdminResult), 'items', function () {
    return this.j1z();
  });
  defineProp(protoOf(SsmListSessionQuery), 'chaincodeUri', function () {
    return this.p20();
  });
  defineProp(protoOf(SsmListSessionResult), 'items', function () {
    return this.j1z();
  });
  defineProp(protoOf(SsmListSsmQuery), 'chaincodeUri', function () {
    return this.p20();
  });
  defineProp(protoOf(SsmListSsmResult), 'items', function () {
    return this.j1z();
  });
  defineProp(protoOf(SsmListUserQuery), 'chaincodeUri', function () {
    return this.p20();
  });
  defineProp(protoOf(SsmListUserResult), 'items', function () {
    return this.j1z();
  });
  //endregion
  //region block: init
  Companion_instance = new Companion();
  Companion_instance_0 = new Companion_0();
  Companion_instance_1 = new Companion_1();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm$chaincode$dsl$blockchain = $ssm$chaincode$dsl.blockchain || ($ssm$chaincode$dsl.blockchain = {});
    $ssm$chaincode$dsl$blockchain.Block = Block;
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm$chaincode$dsl$blockchain = $ssm$chaincode$dsl.blockchain || ($ssm$chaincode$dsl.blockchain = {});
    $ssm$chaincode$dsl$blockchain.EnvelopeType = EnvelopeType;
    $ssm$chaincode$dsl$blockchain.EnvelopeType.values = values;
    $ssm$chaincode$dsl$blockchain.EnvelopeType.valueOf = valueOf;
    defineProp($ssm$chaincode$dsl$blockchain.EnvelopeType, 'TRANSACTION_ENVELOPE', EnvelopeType_TRANSACTION_ENVELOPE_getInstance);
    defineProp($ssm$chaincode$dsl$blockchain.EnvelopeType, 'ENVELOPE', EnvelopeType_ENVELOPE_getInstance);
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm$chaincode$dsl$blockchain = $ssm$chaincode$dsl.blockchain || ($ssm$chaincode$dsl.blockchain = {});
    $ssm$chaincode$dsl$blockchain.IdentitiesInfo = IdentitiesInfo;
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm$chaincode$dsl$blockchain = $ssm$chaincode$dsl.blockchain || ($ssm$chaincode$dsl.blockchain = {});
    $ssm$chaincode$dsl$blockchain.Transaction = Transaction;
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm$chaincode$dsl$config = $ssm$chaincode$dsl.config || ($ssm$chaincode$dsl.config = {});
    $ssm$chaincode$dsl$config.ChaincodeSsmConfig = ChaincodeSsmConfig;
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm$chaincode$dsl$model = $ssm$chaincode$dsl.model || ($ssm$chaincode$dsl.model = {});
    $ssm$chaincode$dsl$model.Agent = Agent;
    defineProp($ssm$chaincode$dsl$model.Agent, 'Companion', Companion_getInstance);
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm$chaincode$dsl$model = $ssm$chaincode$dsl.model || ($ssm$chaincode$dsl.model = {});
    $ssm$chaincode$dsl$model.Chaincode = Chaincode;
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm$chaincode$dsl$model = $ssm$chaincode$dsl.model || ($ssm$chaincode$dsl.model = {});
    $ssm$chaincode$dsl$model.Ssm = Ssm;
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm$chaincode$dsl$model = $ssm$chaincode$dsl.model || ($ssm$chaincode$dsl.model = {});
    $ssm$chaincode$dsl$model.SsmContext = SsmContext;
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm$chaincode$dsl$model = $ssm$chaincode$dsl.model || ($ssm$chaincode$dsl.model = {});
    $ssm$chaincode$dsl$model.SsmGrant = SsmGrant;
    $ssm$chaincode$dsl$model.Credit = Credit;
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm$chaincode$dsl$model = $ssm$chaincode$dsl.model || ($ssm$chaincode$dsl.model = {});
    $ssm$chaincode$dsl$model.SsmSession = SsmSession;
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm$chaincode$dsl$model = $ssm$chaincode$dsl.model || ($ssm$chaincode$dsl.model = {});
    $ssm$chaincode$dsl$model.SsmSessionState = SsmSessionState;
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm$chaincode$dsl$model = $ssm$chaincode$dsl.model || ($ssm$chaincode$dsl.model = {});
    $ssm$chaincode$dsl$model.SsmSessionStateLog = SsmSessionStateLog;
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm$chaincode$dsl$model = $ssm$chaincode$dsl.model || ($ssm$chaincode$dsl.model = {});
    $ssm$chaincode$dsl$model.SsmTransition = SsmTransition;
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm$chaincode$dsl$model = $ssm$chaincode$dsl.model || ($ssm$chaincode$dsl.model = {});
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm$chaincode$dsl$model = $ssm$chaincode$dsl.model || ($ssm$chaincode$dsl.model = {});
    var $ssm$chaincode$dsl$model$uri = $ssm$chaincode$dsl$model.uri || ($ssm$chaincode$dsl$model.uri = {});
    $ssm$chaincode$dsl$model$uri.ChaincodeUri = ChaincodeUri;
    defineProp($ssm$chaincode$dsl$model$uri.ChaincodeUri, 'Companion', Companion_getInstance_0);
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm$chaincode$dsl$model = $ssm$chaincode$dsl.model || ($ssm$chaincode$dsl.model = {});
    var $ssm$chaincode$dsl$model$uri = $ssm$chaincode$dsl$model.uri || ($ssm$chaincode$dsl$model.uri = {});
    $ssm$chaincode$dsl$model$uri.SsmUri = SsmUri;
    defineProp($ssm$chaincode$dsl$model$uri.SsmUri, 'Companion', Companion_getInstance_1);
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm$chaincode$dsl$query = $ssm$chaincode$dsl.query || ($ssm$chaincode$dsl.query = {});
    $ssm$chaincode$dsl$query.SsmGetAdminQuery = SsmGetAdminQuery;
    $ssm$chaincode$dsl$query.SsmGetAdminResult = SsmGetAdminResult;
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm$chaincode$dsl$query = $ssm$chaincode$dsl.query || ($ssm$chaincode$dsl.query = {});
    $ssm$chaincode$dsl$query.SsmGetQuery = SsmGetQuery;
    $ssm$chaincode$dsl$query.SsmGetResult = SsmGetResult;
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm$chaincode$dsl$query = $ssm$chaincode$dsl.query || ($ssm$chaincode$dsl.query = {});
    $ssm$chaincode$dsl$query.SsmGetSessionLogsQuery = SsmGetSessionLogsQuery;
    $ssm$chaincode$dsl$query.SsmGetSessionLogsQueryResult = SsmGetSessionLogsQueryResult;
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm$chaincode$dsl$query = $ssm$chaincode$dsl.query || ($ssm$chaincode$dsl.query = {});
    $ssm$chaincode$dsl$query.SsmGetSessionQuery = SsmGetSessionQuery;
    $ssm$chaincode$dsl$query.SsmGetSessionResult = SsmGetSessionResult;
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm$chaincode$dsl$query = $ssm$chaincode$dsl.query || ($ssm$chaincode$dsl.query = {});
    $ssm$chaincode$dsl$query.SsmGetTransactionQuery = SsmGetTransactionQuery;
    $ssm$chaincode$dsl$query.SsmGetTransactionQueryResult = SsmGetTransactionQueryResult;
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm$chaincode$dsl$query = $ssm$chaincode$dsl.query || ($ssm$chaincode$dsl.query = {});
    $ssm$chaincode$dsl$query.SsmGetUserQuery = SsmGetUserQuery;
    $ssm$chaincode$dsl$query.SsmGetUserResult = SsmGetUserResult;
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm$chaincode$dsl$query = $ssm$chaincode$dsl.query || ($ssm$chaincode$dsl.query = {});
    $ssm$chaincode$dsl$query.SsmListAdminQuery = SsmListAdminQuery;
    $ssm$chaincode$dsl$query.SsmListAdminResult = SsmListAdminResult;
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm$chaincode$dsl$query = $ssm$chaincode$dsl.query || ($ssm$chaincode$dsl.query = {});
    $ssm$chaincode$dsl$query.SsmListSessionQuery = SsmListSessionQuery;
    $ssm$chaincode$dsl$query.SsmListSessionResult = SsmListSessionResult;
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm$chaincode$dsl$query = $ssm$chaincode$dsl.query || ($ssm$chaincode$dsl.query = {});
    $ssm$chaincode$dsl$query.SsmListSsmQuery = SsmListSsmQuery;
    $ssm$chaincode$dsl$query.SsmListSsmResult = SsmListSsmResult;
    var $ssm = _.ssm || (_.ssm = {});
    var $ssm$chaincode = $ssm.chaincode || ($ssm.chaincode = {});
    var $ssm$chaincode$dsl = $ssm$chaincode.dsl || ($ssm$chaincode.dsl = {});
    var $ssm$chaincode$dsl$query = $ssm$chaincode$dsl.query || ($ssm$chaincode$dsl.query = {});
    $ssm$chaincode$dsl$query.SsmListUserQuery = SsmListUserQuery;
    $ssm$chaincode$dsl$query.SsmListUserResult = SsmListUserResult;
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  //endregion
  return _;
}));

//# sourceMappingURL=fixers-c2-c2-ssm-ssm-chaincode-ssm-chaincode-dsl.js.map
